var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"mr-4",attrs:{"title":_vm.title}},[_c('v-icon',{staticClass:"mr-1",staticStyle:{"margin-top":"-5px"},attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }